import type { Components } from "react-markdown";
import {
	compactMarkdownComponents,
	markdownComponents,
} from "@/components/common/markdown-components";
import { ChatMarkdownLink, WorkspaceInlineCode } from "./WorkspaceInlineCode";
import { WorkspaceMarkdownImage } from "./WorkspaceMarkdownImage";

const chatOverrides = {
	a: ChatMarkdownLink,
	code: WorkspaceInlineCode,
	img: WorkspaceMarkdownImage,
} satisfies Components;

export const chatMarkdownComponents: Components = { ...markdownComponents, ...chatOverrides };

export const compactChatMarkdownComponents: Components = {
	...compactMarkdownComponents,
	...chatOverrides,
};
